var React = require('react');

function SortDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 12L0.803847 3L11.1962 3L6 12Z"}));
}

SortDown.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = SortDown;

SortDown.default = SortDown;
